
























































































































































import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';
import { Inject } from '@cds/common';
import { NuoxiaoerService } from '@/services/nuoxiaoer-service';
import { ElForm } from 'element-ui/types/form';

@Component({
  components: {}
})
export default class KpiContentPopup extends Vue {
  @Inject(NuoxiaoerService) private nuoxiaoerService!: NuoxiaoerService;

  @Emit('saved') // 父级接收事件名
  private async emitSaved(): Promise<void> {
    // return this.xxxxxx; // 父级接收的值
  }

  @Emit('cancel') // 父级接收事件名
  private async emitClose(): Promise<void> {
    // return this.xxxxxx; // 父级接收的值
  }

  @Prop() private contentId!: Number;

  @Watch('contentId', { immediate: true, deep: true })
  public onChangeContentId(newVal: any, oldVal: any) {
    console.log('contentId watch', newVal)
    const isEdit = typeof newVal === 'number';
    this.isEdit = isEdit;
    console.log('isEdit',isEdit)
    if (isEdit) {
      this.fetchContentDetail();
    } else {
      // 新增模式，需要清空所有数据并重新初始化
      this.resetFormData();
      this.fetchFolderOptions();
    }
  }

  // 添加组件激活时的生命周期钩子
  public activated(): void {
    // 每次组件激活时，如果不是编辑模式，都重置表单数据
    if (!this.isEdit) {
      this.resetFormData();
      this.fetchFolderOptions();
    }
  }

  public isEdit: Boolean = false;

  // 表单数据
  public formData: any = {
    id: '', // 记录ID
    groupId: '', // 主目录ID
    groupName: '', // 主目录名称
    folderId: '', // 子目录ID
    folderName: '', // 子目录名称
    postLevel: '', // Post Level
    detailUrl: '', // 详情跳转地址
    contentNum: 0, // 考核项数量
    contentVOS: [] // 考核项列表
  };

  // 子目录选项列表
  public folderOptions: any[] = [];

  // 表单校验规则
  public rules: any = {
    folderId: [{ required: true, message: '请选择子目录', trigger: 'change' }],
    postLevel: [{ required: true, message: '请选择Post Level', trigger: 'change' }]
  };

  // 是否可以编辑Post Level
  public canEditPostLevel: boolean = true;
  // 加载状态
  public loading: boolean = false;
  // 当前子目录的Post Level
  public folderPostLevel: string = '全部';

  public async created(): Promise<void> {
  }

  // 获取子目录选项列表
  private async fetchFolderOptions(): Promise<void> {
    this.loading = true;
    try {
      const res = await this.nuoxiaoerService.fetchKpiFolderOption({});
      this.loading = false;

      if (res && Array.isArray(res)) {
        this.folderOptions = res;
      }
    } catch (error) {
      this.loading = false;
      console.error('获取子目录选项列表失败：', error);
      this.$message.error('获取子目录选项列表失败，请刷新重试');
    }
  }

  // 获取考核内容详情
  private async fetchContentDetail(): Promise<void> {
    this.loading = true;
    try {
      const res = await this.nuoxiaoerService.fetchKpiContentDetail({ id: this.contentId });
      this.loading = false;

      if (res) {
        // 编辑模式下直接使用详情接口返回的数据
        this.formData = {
          id: res.id,
          groupId: res.groupId,
          groupName: res.groupName || '', // 使用接口返回的groupName
          folderId: res.folderId,
          folderName: res.folderName || '', // 使用接口返回的folderName
          postLevel: res.postLevel || '',
          detailUrl: res.detailUrl || '',
          contentNum: res.contentNum || 0,
          contentVOS: Array.isArray(res.contentVOS) ? res.contentVOS.sort((a, b) => a.sortNumber - b.sortNumber) : []
        };

        // 设置子目录的Post Level限制
        // 在编辑模式下，我们根据接口返回的postLevel来确定是否可编辑
        if (res.postLevel === 'MR' || res.postLevel === 'DM') {
          this.folderPostLevel = res.postLevel;
          this.canEditPostLevel = false;
        } else {
          this.folderPostLevel = '全部';
          this.canEditPostLevel = true;
        }
      }
    } catch (error) {
      this.loading = false;
      console.error('获取考核内容详情失败：', error);
      this.$message.error('获取考核内容详情失败，请刷新重试');
    }
  }

  // 子目录变更处理
  public handleFolderChange(value: string): void {
    const folder = this.folderOptions.find(item => item.id === value);
    if (folder) {
      // 更新子目录的名称
      this.formData.folderName = folder.name;

      // 更新主目录的信息
      this.formData.groupId = folder.groupId;
      this.formData.groupName = folder.groupName;

      // 更新子目录的Post Level
      this.folderPostLevel = folder.postLevel || '全部';

      // 设置默认的Post Level
      this.formData.postLevel = this.folderPostLevel;

      // 更新是否可以编辑Post Level
      this.updateCanEditPostLevel();
    }
  }

  // 更新是否可以编辑Post Level
  private updateCanEditPostLevel(): void {
    this.canEditPostLevel = this.folderPostLevel === '全部';
  }

  // 获取可选的Post Level选项
  public getAvailablePostLevels(): string[] {
    if (this.folderPostLevel === '全部') {
      return ['全部', 'MR', 'DM'];
    } else if (this.folderPostLevel === 'MR') {
      return ['MR'];
    } else if (this.folderPostLevel === 'DM') {
      return ['DM'];
    } else {
      return ['全部'];
    }
  }

  // 添加考核项
  public addContentItem(): void {
    // 计算新的排序号（当前最大排序号+1）
    let maxSortNumber = 0;
    if (this.formData.contentVOS.length > 0) {
      this.formData.contentVOS.forEach((item: any) => {
        if (item.sortNumber && item.sortNumber > maxSortNumber) {
          maxSortNumber = item.sortNumber;
        }
      });
    }

    const newContentItem = {
      id: '',
      groupId: this.formData.groupId,
      folderId: this.formData.folderId,
      name: '',
      content: '',
      sortNumber: maxSortNumber + 1,
      createdTime: null
    };

    this.formData.contentVOS.push(newContentItem);
  }

  // 删除考核项
  public async removeContentItem(index: number): Promise<void> {
    try {
      // 确认删除
      await this.$confirm('是否删除该信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });

      this.formData.contentVOS.splice(index, 1);
    } catch (error) {
      // 用户取消删除操作
      console.log('取消删除');
    }
  }

  // 重置表单数据
  private resetFormData(): void {
    this.formData = {
      id: '',
      groupId: '',
      groupName: '',
      folderId: '',
      folderName: '',
      postLevel: '',
      detailUrl: '',
      contentNum: 0,
      contentVOS: []
    };
    
    // 重置其他状态
    this.canEditPostLevel = true;
    this.folderPostLevel = '全部';
    this.folderOptions = [];
    
    // 清除表单验证状态
    this.$nextTick(() => {
      if (this.$refs.contentForm) {
        (this.$refs.contentForm as ElForm).clearValidate();
      }
      if (this.$refs.contentItemForm) {
        (this.$refs.contentItemForm as ElForm).clearValidate();
      }
    });
  }

  // 提交表单
  public submitForm(): void {
    // 先验证基本信息表单
    (this.$refs.contentForm as ElForm).validate(async (isValid: boolean, invalidFields: object) => {
      if (!isValid) {
        this.$message.error('请检查并完善基本信息');
        return;
      }

      // 验证考核项表单
      let contentFormValid = true;
      if (this.$refs.contentItemForm) {
        await new Promise((resolve) => {
          (this.$refs.contentItemForm as ElForm).validate((valid: boolean) => {
            contentFormValid = valid;
            resolve(valid);
          });
        });
      }

      if (!contentFormValid) {
        this.$message.error('请检查并完善考核项信息');
        return;
      }

      // 验证考核项列表
      if (!this.validateContentItems()) {
        return;
      }

      try {
        // 确认保存
        await this.$confirm('是否确认信息发布？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'info'
        });

        // 构建提交数据
        const submitData: any = {
          id: this.formData.id || null,
          groupId: this.formData.groupId,
          folderId: this.formData.folderId,
          contentNum: this.formData.contentVOS.length,
          postLevel: this.formData.postLevel,
          detailUrl: this.formData.detailUrl || '',
          contentVOS: this.formData.contentVOS.map((item: any) => {
            return {
              id: item.id || null,
              groupId: this.formData.groupId,
              folderId: this.formData.folderId,
              name: item.name,
              content: item.content,
              sortNumber: item.sortNumber,
              createdTime: item.createdTime
            };
          })
        };

        console.log('提交数据:', submitData);

        // 保存数据
        await this.nuoxiaoerService.saveKpiContent(submitData);

        this.$message({
          message: '保存成功',
          type: 'success'
        });

        this.emitSaved();
      } catch (error) {
        if (error === 'cancel') {
          // 用户取消操作，不做处理
          return;
        }
        console.error('保存失败：', error);
        this.$message.error('保存失败：' + (error.message || '未知错误'));
      }
    });
  }

  // 验证考核项列表
  private validateContentItems(): boolean {
    // 验证基本信息必填项
    if (!this.formData.folderId) {
      this.$message.error('请选择子目录');
      return false;
    }

    if (!this.formData.postLevel) {
      this.$message.error('请选择Post Level');
      return false;
    }

    // 验证考核项列表 - 至少要有一个考核项
    // if (this.formData.contentVOS.length === 0) {
    //   this.$message.error('请至少添加一个考核项');
    //   return false;
    // }

    // 验证每个考核项的必填项
    for (let i = 0; i < this.formData.contentVOS.length; i++) {
      const item = this.formData.contentVOS[i];

      if (!item.name || item.name.trim() === '') {
        this.$message.error(`第${i+1}行考核项名称不能为空`);
        return false;
      }

      if (!item.content || item.content.trim() === '') {
        this.$message.error(`第${i+1}行考核项内容不能为空`);
        return false;
      }

      if (!item.sortNumber && item.sortNumber !== 0) {
        this.$message.error(`第${i+1}行顺序号不能为空`);
        return false;
      }

      if (item.sortNumber < 1) {
        this.$message.error(`第${i+1}行顺序号必须大于0`);
        return false;
      }
    }

    // 检查是否有重复的顺序号
    const sortNumbers = this.formData.contentVOS.map((item: any) => item.sortNumber);
    const uniqueSortNumbers = new Set(sortNumbers);
    if (sortNumbers.length !== uniqueSortNumbers.size) {
      this.$message.error('存在重复的顺序号，请修改');
      return false;
    }

    return true;
  }

  // 取消按钮
  public async handleCancel(): Promise<void> {
    try {
      await this.$confirm('是否关闭当前界面？关闭后，当前界面内容将会丢失', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      });
      this.emitClose();
    } catch (error) {
      // 用户取消操作，不做处理
    }
  }

  // 本地模糊搜索子目录选项
  public filterFolderOptions(query: string): void {
    this.folderSearchQuery = query || '';
  }

  // 子目录搜索框输入事件
  public onFolderSearchInput(value: string): void {
    this.folderSearchQuery = value;
  }

  // 清空子目录搜索框
  public clearFolderSearch(): void {
    this.folderSearchQuery = '';
  }

  // 计算过滤后的子目录选项
  get filteredFolderOptions() {
    if (!this.folderSearchQuery || this.folderSearchQuery.trim() === '') {
      return this.folderOptions;
    }
    const searchQuery = this.folderSearchQuery.toLowerCase().trim();
    return this.folderOptions.filter(option => {
      return option && option.name && option.name.toLowerCase().includes(searchQuery);
    });
  }

  // 子目录搜索框的值
  public folderSearchQuery: string = '';

}
